
import { TrendingUp, Target, SkipForward } from 'lucide-react';
import { PACT } from '@/types/pact';

interface QuickStatsSectionProps {
  activePacts: PACT[];
  getStreak: (pact: PACT) => number;
}

const QuickStatsSection = ({ activePacts, getStreak }: QuickStatsSectionProps) => {
  if (activePacts.length === 0) return null;

  return (
    <div className="grid grid-cols-3 gap-2 mb-6">
      <div className="bg-white rounded-lg p-3 shadow-sm border border-soft-blue/50 text-center">
        <div className="w-6 h-6 bg-vibrant-orange/10 rounded-full flex items-center justify-center mx-auto mb-1">
          <TrendingUp className="w-3 h-3 text-vibrant-orange" />
        </div>
        <div className="text-lg font-bold text-deep-blue">
          {Math.max(...activePacts.map(getStreak), 0)}
        </div>
        <div className="text-xs text-deep-blue/70">Best Streak</div>
      </div>
      
      <div className="bg-white rounded-lg p-3 shadow-sm border border-soft-blue/50 text-center">
        <div className="w-6 h-6 bg-vibrant-orange/10 rounded-full flex items-center justify-center mx-auto mb-1">
          <Target className="w-3 h-3 text-vibrant-orange" />
        </div>
        <div className="text-lg font-bold text-deep-blue">
          {activePacts.reduce((total, pact) => total + pact.completedDays.length, 0)}
        </div>
        <div className="text-xs text-deep-blue/70">Total Shows</div>
      </div>

      <div className="bg-white rounded-lg p-3 shadow-sm border border-soft-blue/50 text-center">
        <div className="w-6 h-6 bg-gray-400/10 rounded-full flex items-center justify-center mx-auto mb-1">
          <SkipForward className="w-3 h-3 text-gray-500" />
        </div>
        <div className="text-lg font-bold text-deep-blue">
          {activePacts.reduce((total, pact) => total + pact.skippedDays.length, 0)}
        </div>
        <div className="text-xs text-deep-blue/70">Total Skips</div>
      </div>
    </div>
  );
};

export default QuickStatsSection;
